import React from "react";
import Carousel from "../../../../../components/Habitacional/Carousel";
import CardProductSelect from "../../../../../components/Habitacional/CardProductSelect";
import ContentSection from "../../../../../components/Habitacional/ContentSection";
import useWindowSize from "../../../../../hooks/useWindowSize";

const CardProduct = [
  {
    cardTitle: "Seguro Habitacional Tradicional",
    cardMainDescription: (
      <>
        Para quem fez um financiamento nas modalidades FGTS, SBPE ou Minha Casa
        Minha Vida.
      </>
    ),
    link: "/paravoce/habitacional/seguro-habitacional-tradicional",
  },
  {
    cardTitle: "Seguro Habitacional Mais",
    cardMainDescription: (
      <>Para quem fez um financiamento nas modalidades FGTS ou SBPE.</>
    ),
    link: "/paravoce/habitacional/seguro-habitacional-mais",
  },
  {
    cardTitle: "Seguro Habitacional Mais Premiável",
    cardMainDescription: (
      <>Para quem fez um financiamento na modalidade Minha Casa Minha Vida</>
    ),
    link: "/paravoce/habitacional/seguro-habitacional-mais-premiavel",
  },
];

const slides = CardProduct.map((product, productIndex) => (
  <CardProductSelect
    key={(product && product[0]?.id) ?? productIndex}
    cardContentItem={[product]}
  />
));

const CarouselContentHomeHabitation = () => {
  const { width } = useWindowSize();
  const isDesktop = width >= 768;

  return (
    <ContentSection
      styled={{ display: "flex", gap: "32px" }}
      title="Selecione seu seguro para saber mais"
    >
      {!isDesktop && <Carousel>{slides}</Carousel>}
      {isDesktop && <CardProductSelect cardContentItem={CardProduct} />}
      <p style={{ marginTop: `${!isDesktop ? "32px" : "0"}` }}>
        Para consultar qual é o seu Seguro Habitacional, verifique seu contrato
        de financiamento ou acesse a{" "}
        <a
          href="https://arealogada.caixaseguradora.com.br/"
          target="_blank"
          style={{ color: "#005FC8" }}
          rel="noreferrer"
        >
          área do cliente
        </a>
        .
      </p>
    </ContentSection>
  );
};

export default CarouselContentHomeHabitation;
